export enum Category {
  food = "FOOD",
  taxi = "TAXI",
  fuel = "FUEL",
  celebrations = "CELEBRATIONS",
  parking = "PARKING_TOLLS",
  accommodation = "ACCOMMODATION",
  infrastructure = "INFRASTRUCTURE",
  laundry = "LAUNDRY",
  ticket = "TICKET",
  telephone = "TELEPHONE",
  transport = "TRANSPORT",
  advance = "ADVANCE",
  others = "OTHERS",
}
